import React, {useState, useEffect} from 'react';
// import logo from '../../logo.svg';
import './App.css';
import Table from '../../Components/Table';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';

function App() {
  const [teams, setTeams] = useState('');
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    fetch('https://getfit.btwb.com/tiggy/xmasrow-production.json', {
      method: 'GET'
    }).then(res => {
      if(!res.ok) return;
      return res.json();
    }).then(response => {
      setLoading(false);
      setTeams(response.leaderboard)
    }).catch(err => {
      setLoading(false);
      console.log(err);
    })
  }

  useEffect(getData, [])

  return (
    <div className="App">
      <Header />
      <div className="donate-banner w-100 pa3 white flex items-center">
        <div className="w-80 pa2 tl f6">
          Julie and Dani are raising money for Barbells for Boobs - an incredible organization that works hard to improve the quality of life of those diagnosed with breast cancer. Breast cancer has hit their family in a big way over the past couple of years. They now know personally how difficult it can be to navigate this process, and want to give back to an organization that is working hard to make it easier for so many.
        </div>
        <div className="w-20">
          <a className="no-underline db mr0" href="https://fundraise.barbellsforboobs.org/fundraiser/pursuing-health">
            <div className="header-button banner-button pa3 mb0 ml-auto mr0">Donate</div>
          </a>
        </div>
      </div>
      <Table
        teams={teams}
      />
      {(teams.length === 0 && !loading) &&
        <div className="mt2">
          <h2 className="tc">No workouts yet!</h2>
        </div>
      }
      <Footer />
    </div>
  );
}

export default App;